{
  "list": {
    "heading": "Avdelning",
    "loading": "Hämtar avdelningslistan …",
    "failed": "Avdelningslistan kunde inte hämtas.",
    "retry": "Försök igen",
    "notFound": "Avdelningen finns inte i journalen.",
    "empty": "Inga patienter är inskrivna på avdelningen.",
    "caption": "Patienter på avdelningen, en rad per vårdplats.",
    "occupancy": "{occupied} av {total} platser belagda{withoutBed, plural, =0 {} other { · # utan plats}}",
    "occupancyWithoutTotal": "{occupied, plural, =0 {Inga patienter inskrivna} one {# patient inskriven} other {# patienter inskrivna}}"
  },
  "column": {
    "bed": "Plats",
    "name": "Namn",
    "identifier": "Personnummer / reservnr",
    "age": "Ålder",
    "admitted": "Inlagd",
    "responsible": "Ansvarig läkare",
    "safety": "Varningar"
  },
  "picker": {
    "label": "Visa avdelning"
  },
  "patient": {
    "responsibleNotDocumented": "Ej dokumenterad"
  }
}
